import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { migrateLegacyUserDrafts } from "../utils/draftKeys";
import { setPageMeta } from "../utils/seo";
import { trackPageVisit } from "../Services/visitorTracking";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    migrateLegacyUserDrafts();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const isPrivate = pathname.startsWith('/admin') || pathname.startsWith('/partner');
    setPageMeta({
      pathname,
      robots: isPrivate ? 'noindex, nofollow' : undefined,
    });
    trackPageVisit(pathname);
  }, [pathname]);

  return null;
};

export default ScrollToTop;